@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        module="document"
        appendToModuleType="shared"
        [moduleType]="moduleType"
        idProp="guid"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [buttonConfig]="buttonConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="getFile($event)"
        (onAddClick)="openDocumentManager()"
    >
    </cerrix-workspace>
}

<div
    class="modal fade"
    role="dialog"
    id="document-add-modal"
    data-backdrop="static"
    data-keyboard="false"
    #addModal
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'sharedDocuments.newDocumentsTitle' | transloco }}</h5>
            </div>
            <div class="container-fluid corrected-size">
                <document-manager-old [(Documents)]="NewDocuments"></document-manager-old>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-cerrix"
                    [disabled]="disabled"
                    (click)="addDocuments()"
                >
                    {{ 'sharedDocuments.addDocumentButton' | transloco }}
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    {{ 'sharedDocuments.cancelButton' | transloco }}
                </button>
            </div>
        </div>
    </div>
</div>

<div
    class="modal fade"
    role="dialog"
    id="document-history-modal"
    data-backdrop="static"
    data-keyboard="false"
    #historyModal
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'sharedDocuments.documentViewerTitle' | transloco }}</h5>
            </div>
            <div class="container-fluid">
                <document-history [guid]="documentHistoryGuid"></document-history>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    {{ 'sharedDocuments.doneButton' | transloco }}
                </button>
            </div>
        </div>
    </div>
</div>
